module.exports = __webpack_public_path__ + "d19.no2.e2b3a7c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/d19.no2.jpg
// module id = rR08
// module chunks = 0